import { PageContent } from "@/components/layout/MainWindow";
import { PageHeader } from "@/components/layout/PageHeader";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/settings/_admin/users/_users",
)({
  component: RouteComponent,
  staticData: {
    meta: {
      title: "Brugere",
    },
  },
});

function RouteComponent() {
  const location = useLocation();

  return (
    <div className="flex h-full flex-col">
      {location.pathname.endsWith("/users") || <PageHeader title="Brugere" />}

      <PageContent className="flex h-full flex-col">
        <Outlet />
      </PageContent>
    </div>
  );
}
